import { createFileRoute } from '@tanstack/react-router';

import { HomePage } from './HomePage';
import { z } from 'zod';

const searchSchema = z.object({
  account: z.string().optional(),
  plaid_connected: z.boolean().optional(),
});

export const Route = createFileRoute('/_protected/_consumer/')({
  component: HomePage,
  validateSearch: searchSchema,
});
